import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-folder",
  "use": "icon-folder-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-folder\"><path d=\"M868.6 241.5c-0.3-8.7-7.3-15.6-16.1-15.6h-338c-1.8 0-3.2-1.4-3.2-3.2v-61.9c0-3.5-2.9-6.4-6.4-6.4h-335c-8.9 0-16.2 7.3-16.2 16.2v682.5c0 8.9 7.3 16.2 16.2 16.2h682.6c8.9 0 16.2-7.3 16.2-16.2V241.6h-0.1z m-650.8 43.1v-66.2h229.4v4.3c0 37.1 30.2 67.3 67.3 67.3h290.2v60.8H217.8v-66.2z m586.9 520.7H217.8V414.8h586.9v390.5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol